module.exports = __webpack_public_path__ + "static/media/json.ea72658b.png";